import React, { useState, useEffect } from 'react';
import { Typography, TextField, Button, Snackbar, Divider, CircularProgress } from '@material-ui/core';
import { useSelector } from 'react-redux'

import Alert from './Alert' 

// import AddIcon from '@material-ui/icons/Add';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TrendingDownIcon from '@material-ui/icons/TrendingDown';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import AddIcon from '@material-ui/icons/Add';

import { ClearOutlined, ArrowBack, ArrowUpward, ArrowDownward } from '@material-ui/icons';

import { CssTextField } from './DarkModeTextField'

import { fetchDataFromAPIAdvIntraday, fetchDataFromAPIReturnHeikinAshiValue } from './constant'

import DateFnsUtils from "@date-io/date-fns"; // choose your lib
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import {
    CssCalendarField,
    CssLightCalendarField,
} from "./DarkModeTextField";

//Store functions
import  store, {
    changeInterval,
    setCandleData,
    setCurrentPhaseLoading,
    addNewTab,
    changeSwingType,
    setSwing,
    hideOrDisplayElement,
    changeCaptionName,
    handleDeleteTab,
    updateAdditionalDataCalc,
    updateInitPhaseCalc,
    updateOrderPlacementCalc,
    switchTabs,
    updateLastCloseValue,
    pushStockData,
    onlyDisplayElement,
    instrumentChange,
    exchangeChange,
    changeEndTime,
    changeEndDate,
    changeExpiryDate,
    changeSymbol,
    updatePhaseValues,
    setPhase,
    removeLastElementInPhaseVale,
    updateCurrentPhaseCalc,
    updateTabDataInDB,
    setSymbols,
    expiryChange, 

} from './store'

const AdvancedIntraday = () => {
    const oldTabs = useSelector((state)=> state.initFunction.advancedIntradayTabs);
    const protectiveFactors = useSelector((state)=> state.initFunction.protectiveFactorsForPositional);
    const newConstants = useSelector((state)=> state.initFunction.newConstForAdvIntraday);    
    const constForConfEntryPositional = useSelector((state)=> state.initFunction.constForConfEntryAdvIntraday);    
    const isSmallScreen = useSelector((state)=> state.initFunction.isSmallScreen);
    const selectedTab = useSelector((state)=> state.initFunction.advancedIntradaySelectedTab);
    const instruments = useSelector((state)=> state.initFunction.instrumentsNameAndKey);
    const exchanges = useSelector((state)=> state.initFunction.exchanges);
    const timeIntervals = useSelector((state)=> state.initFunction.timeIntervals);
    const candleIntervals = useSelector((state)=> state.initFunction.candleIntervals);
    const expiryMonths = useSelector((state) => state.initFunction.expiryMonths)
    const symbols = useSelector((state) => state.initFunction.symbolsListAppearInForm);
    const symbolsCopy = useSelector((state) => state.initFunction.symbols);

    const darkMode = useSelector((state)=> state.initFunction.darkMode);

    const selectedTabColorsInDarkMode = useSelector((state)=> state.initFunction.selectedTabColorsInDarkMode)
    const tabColorsInDarkMode = useSelector((state)=> state.initFunction.tabColorsInDarkMode)
    const selectedTabColorsInLightMode = useSelector((state)=> state.initFunction.selectedTabColorsInLightMode)
    const tabColorsInLightMode = useSelector((state)=> state.initFunction.tabColorsInLightMode)
    const allBorderColorsInLightMode = useSelector((state)=> state.initFunction.allBorderColorsInLightMode)
    const allBorderColorsInDarkMode = useSelector((state)=> state.initFunction.tabColorsInDarkMode)
    const sideHeadingColor = useSelector((state)=> state.initFunction.sideHeadingColor);

    const currentPhaseLoading = useSelector((state) => state.initFunction.currentPhaseLoading);

    
    //True Data Creds
    const userName = useSelector((state)=> state.initFunction.userName)
    const password = useSelector((state)=> state.initFunction.password)

    const [ hideInitPhaseDiv, setInitPhaseDiv ] = useState(true)

    const [ openSnackBar, setSnackBar ] = useState(false)
    const [ snackMessage, setSnackMessage ] = useState('Symbol not exist')
    const [ snackStatus, setSnackStatus ] = useState('')
    
    const vertical = 'top'
    const horizontal = 'right'
    const swingTypes = [ "Standard", "Medium" ];

    useEffect(() => {
        document.title = "Advanced Intraday"
        
        if(oldTabs.length > 0) {
            if(oldTabs[selectedTab]['inst']) {
              let toSetSymbols = []
              for(let i in symbolsCopy) {
                if(instruments[oldTabs[selectedTab]['inst']]['key'] === symbolsCopy[i]['ty']) {
                  toSetSymbols.push(symbolsCopy[i])
                }
              }
              store.dispatch(setSymbols({ data: toSetSymbols }))
            }
          }
    }, [])

    function higestValue (a, index) {
        if (index > 0) {
          return Math.max(a[index], higestValue(a, index - 1));
        } else {
          return a[0];
        }
    }

    function lowestValue (a, index) {
        if (index > 0) {
            return Math.min(a[index], lowestValue(a, index - 1));
        } else {
            return a[0];
        }
    }

    const handleHideElement = ( key ) => {
        store.dispatch(hideOrDisplayElement({ index: selectedTab, elementName: key, arrayName: "advancedIntradayTabs" }))
        setInitPhaseDiv(!hideInitPhaseDiv)
    }

    const handleChangeTabs = (index) => {
        store.dispatch(switchTabs({ index: index, keyName: "advancedIntradaySelectedTab" }))
    }

    const addZeroPrefixInString = (key) => {
        return key.toString().length == 1 ? "0" + key : key
    }

    const handleSelectForm = (index) => {
        if(!oldTabs[selectedTab]["endDate"]) {
            setSnackMessage("Please select the end date")
            setSnackStatus("error")
            setSnackBar(true)
            return
        }

        let  toDate = new Date(oldTabs[index]['endDate'])
        toDate.setDate(toDate.getDate() - 3)

        if(oldTabs[index]['interval'] === "60mins") {
            toDate.setDate(toDate.getDate() - 6)
        }

        if(oldTabs[index]['interval'] === "30mins") {
            toDate.setDate(toDate.getDate() - 4)
        }

        let fromDate = toDate
        toDate = new Date(oldTabs[index]['endDate'])

        let fromDateYear = fromDate.getFullYear().toString()[2] + fromDate.getFullYear().toString()[3]
        let fromDateMonth = (fromDate.getMonth() + 1).toString()
        let fromDateDay = fromDate.getDate().toString()

        let toDateYear = toDate.getFullYear().toString()[2] + toDate.getFullYear().toString()[3]
        let toDateMonth = (toDate.getMonth() + 1).toString()
        let toDateDay = toDate.getDate().toString()

        toDate = addZeroPrefixInString(toDateYear) + addZeroPrefixInString(toDateMonth) + addZeroPrefixInString(toDateDay) + "T15:15:00"

        if (oldTabs[index]['interval'] === '15mins') {
            toDate = addZeroPrefixInString(toDateYear) + addZeroPrefixInString(toDateMonth) + addZeroPrefixInString(toDateDay) + "T" + oldTabs[index]['endTime'] + ":00"
        }
        fromDate = addZeroPrefixInString(fromDateYear) + addZeroPrefixInString(fromDateMonth) + addZeroPrefixInString(fromDateDay) + "T09:15:00"

        let symbol = oldTabs[index]["symbol"]
        let currentDate = new Date()
        if(oldTabs[index]["inst"] === 1) {
            symbol = symbol + addZeroPrefixInString(currentDate.getFullYear().toString()[2] + currentDate.getFullYear().toString()[3]) + oldTabs[index]["expiry"] + "FUT"
        }

        let toDateInYYYYMMDDFormat = new Date(oldTabs[index]['endDate'])
        toDateInYYYYMMDDFormat = toDateInYYYYMMDDFormat.getFullYear().toString() + '-' + (toDateInYYYYMMDDFormat.getMonth() + 1).toString() + '-' + toDateInYYYYMMDDFormat.getDate().toString()

        fetchDataFromAPIAdvIntraday(symbol, fromDate, toDate, "15min", function(normalData) {
            if (normalData["error"] === true) {
                setSnackMessage(normalData["status"]);
                setSnackStatus("error");
                setSnackBar(true);
                return;
            }

            let obj = {}
            let stockData = []

            if(oldTabs[index]['interval'] === "30mins") {
                for(let i = 0; i < normalData.length; i++) {
                    if(normalData[i]['date'].split("T")[1] === "15:15:00") {
                        normalData.splice(i, 1)
                    }

                    if(normalData[i]['date'].split("T")[1] === "16:00:00") {
                        normalData.splice(i, 1)
                    }

                    if(normalData[i]['date'].split("T")[1] === "09:00:00") {
                        normalData.splice(i, 1)
                    }
                }

                for(let j = 0; j < normalData.length; j = j + 2) {
                    if(j <= (normalData.length - 2)) {
                        obj = {
                            date: normalData[j]['date'],
                            open: normalData[j]['open'],
                            high: normalData[j]['high'] > normalData[j + 1]['high'] ? normalData[j]['high'] : normalData[j + 1]['high'],
                            low: normalData[j]['low'] < normalData[j + 1]['low'] ? normalData[j]['low'] : normalData[j + 1]['low'],
                            close: normalData[j + 1]['close']
                        }
                        stockData.push(obj)
                        obj = {}
                    }
                }

                for(let k = stockData.length - 1; k >= 0; k--) {
                    if(new Date(stockData[k]['date'].split('T')[0]).toDateString() === new Date(oldTabs[index]['endDate']).toDateString()) {
                        if(stockData[k]['date'].split('T')[1] >= oldTabs[index]['endTime']) {
                            stockData.splice(k, 1)
                        }
                    }
                }

                stockData = stockData.slice(Math.abs(stockData.length - 10))
            }

            if(oldTabs[index]['interval'] === "60mins") {
                for(let i = 0; i < normalData.length; i++) {
                    if(normalData[i]['date'].split("T")[1] === "15:15:00") {
                        normalData.splice(i, 1)
                    }

                    if(normalData[i]['date'].split("T")[1] === "16:00:00") {
                        normalData.splice(i, 1)
                    }

                    if(normalData[i]['date'].split("T")[1] === "09:00:00") {
                        normalData.splice(i, 1)
                    }
                }

                for(let j = 0; j < normalData.length; j = j + 4) {
                    if(j <= (normalData.length - 4)) {
                        obj = {
                            date: normalData[j]['date'],
                            open: normalData[j]['open'],
                            high: higestValue([normalData[j]['high'], normalData[j + 1]['high'], normalData[j + 2]['high'], normalData[j + 3]['high']], 3),
                            low: lowestValue([normalData[j]['low'], normalData[j + 1]['low'], normalData[j + 2]['low'], normalData[j + 3]['low']], 3),
                            close: normalData[j + 3]['close']
                        }
                        stockData.push(obj)
                        obj = {}
                    }
                }

                for(let k = stockData.length - 1; k >= 0; k--) {
                    if(new Date(stockData[k]['date'].split('T')[0]).toDateString() === new Date(oldTabs[index]['endDate']).toDateString()) {
                        if(stockData[k]['date'].split('T')[1] > oldTabs[index]['endTime']) {
                            stockData.splice(k, 1)
                        }
                    }
                }

                stockData = stockData.slice(Math.abs(stockData.length - 10))
            }

            if(oldTabs[index]['interval'] === "15mins") {
                stockData = normalData.slice(Math.abs(normalData.length - 10))
            }

            if(oldTabs[selectedTab]['data'].length == 10) {
                store.dispatch(updateInitPhaseCalc({ index: selectedTab, data: [], arrayName: "advancedIntradayTabs" }))
                store.dispatch(updateCurrentPhaseCalc({ index: selectedTab, data: [], key: 'advancedIntradayTabs' }))
                store.dispatch(updateOrderPlacementCalc({ index: selectedTab, data: { "buy": [], "sell": [] }, arrayName: "advancedIntradayTabs" }))
                store.dispatch(updateAdditionalDataCalc({ index: selectedTab, data: [], arrayName: "advancedIntradayTabs" }))
                store.dispatch(setSwing({ index: selectedTab, data: 0, value: 0, arrayName: 'advancedIntradayTabs' }))
                store.dispatch(setCandleData({arrayName: "advancedIntradayTabs", selectedTabIndex: selectedTab, data: {} }));
            }

            setTimeout(() => {                    
                store.dispatch(pushStockData({ index: selectedTab, arrayName: "advancedIntradayTabs", data: stockData }))
                store.dispatch(onlyDisplayElement({ index: selectedTab, elementName: 'hideDataDiv', arrayName: "advancedIntradayTabs" }))
                store.dispatch(hideOrDisplayElement({ index: selectedTab, elementName: 'hideSelectForm', arrayName: "advancedIntradayTabs" }))
                setInitPhaseDiv(!hideInitPhaseDiv)

                const key = oldTabs[selectedTab]

                let dataToUpdate = {
                    labelName: key['labelName'],
                    exchange: key['exchange'],                
                    symbol:key['symbol'],
                    interval: key["interval"],
                    endDate: key['endDate'].toString(),
                    endTime: key['endTime'],
                    inst: key['inst'],
                    expiry: key['expiry'],
                    isDataFromManual: false,

                    swing: key['swing'],
                    swingVal: key['swingVal'],
                    swingType: key['swingType'],
                    candleData: key["candleData"],
                    
                    data: key['data'],
                    initPhase: key['initPhase'],
                    currentPhase: key['currentPhase'],
                    orderPlaceMentBuy: key['orderPlaceMentBuy'],
                    orderPlaceMentSell: key['orderPlaceMentSell'],
                    additionalDetails: key['additionalDetails'],
                    hideSelectForm: key['hideSelectForm'],
                    hideDataDiv: key['hideDataDiv'],
                    hideInitPhaseDiv: key['hideInitPhaseDiv'],
                    orderPlacementDiv: key['orderPlacementDiv'],
                    currentPhaseDiv: key['currentPhaseDiv'],
                    additionalDetailsDiv: key['additionalDetailsDiv'],
                    notify: key['notify'],
        
                    upPhasedValues: key["upPhasedValues"],
                    downPhasedValues: key["downPhasedValues"],
                    whichPhase: key["whichPhase"]
                }

                store.dispatch(updateTabDataInDB({ docId: oldTabs[selectedTab]['docId'], docName: 'advancedIntradayTabs', tabDataToUpdate: dataToUpdate }))
            }, 500);
        })
    }

    const handleCalculate = (calculateTrend, nextPhaseValue, whichPhaseIsThis, goPrevPhaseValue, currentPhase, swingType, candleData, currentPhaseAgain) => {
        let prevTrend = '';
        let currentTrend = '';
        let swingValue = oldTabs[selectedTab]['data'][9]['close']

        if(calculateTrend) {
            // Here will find market trend
            for(var i = oldTabs[selectedTab]['data'].length - 1; i >= 0; i--) {
                let item = oldTabs[selectedTab]['data'][i]
                let latestTrend = ''

                if( i !== 9 ) {
                    if( oldTabs[selectedTab]['data'][i + 1]['close'] > item.close) {
                        latestTrend = "BUY"
                        if(i === 8) {
                            prevTrend = latestTrend
                            currentTrend = latestTrend
                        }
                    } else if( oldTabs[selectedTab]['data'][i + 1]['close'] < item.close ) {
                        latestTrend = "SELL"
                        if(i === 8) {
                            prevTrend = latestTrend      
                            currentTrend = latestTrend
                        }
                    } else if(oldTabs[selectedTab]['data'][i - 1]['close'] > item.close) {
                        latestTrend = "BUY"
                        if(i === 8) {
                            prevTrend = latestTrend
                            currentTrend = latestTrend
                        }
                    } else if( oldTabs[selectedTab]['data'][i - 1]['close'] < item.close ) {
                        latestTrend = "SELL"
                        if(i === 8) {
                            prevTrend = latestTrend      
                            currentTrend = latestTrend
                        }
                    } else if(oldTabs[selectedTab]['data'][i - 2]['close'] > item.close) {
                        latestTrend = "BUY"
                        if(i === 8) {
                            prevTrend = latestTrend
                            currentTrend = latestTrend
                        }
                    } else if( oldTabs[selectedTab]['data'][i - 2]['close'] < item.close ) {
                        latestTrend = "SELL"
                        if(i === 8) {
                            prevTrend = latestTrend      
                            currentTrend = latestTrend
                        }
                    }
                }

                // Calculating the swing value
                if(latestTrend !== prevTrend) {
                    let swingIndex = i
                    if ( currentTrend === "BUY" ) {
                        // This part will handle if the trend is BUY
                        let latestSwingLow = oldTabs[selectedTab]["data"][0]["low"];

                        // Looking for value swing in low column & figuring the first swing index.
                        for (var buy = 9; buy >= 0; buy--) {
                            if (latestSwingLow > oldTabs[selectedTab]["data"][buy]["low"]) {
                                latestSwingLow = oldTabs[selectedTab]["data"][buy]["low"];
                            }

                            if(buy !== 0) {
                                if(oldTabs[selectedTab]["data"][buy]["low"] < oldTabs[selectedTab]["data"][buy - 1]["low"]) {                  
                                    latestSwingLow = oldTabs[selectedTab]["data"][buy]["low"];
                                    break
                                }
                            }
                        }
    
                        swingValue = latestSwingLow
                        store.dispatch(setSwing({ index: selectedTab, data: 2, value: Number(swingValue), arrayName: 'advancedIntradayTabs' })) // Swing is LOW                    
                    } else if ( currentTrend === "SELL") {
                        // This part will handle if the trend is SELL
                        let latestSwingHigh = oldTabs[selectedTab]["data"][swingIndex]["high"];

                        // Similar to the above comments in BUY Side.
                        for (var buy = 9; buy >= 0; buy--) {
                            if (latestSwingHigh < oldTabs[selectedTab]["data"][buy]["high"]) {
                                latestSwingHigh = oldTabs[selectedTab]["data"][buy]["high"];
                            }

                            if(buy !== 0) {
                                if(oldTabs[selectedTab]["data"][buy]["high"] > oldTabs[selectedTab]["data"][buy - 1]["high"]) {                  
                                    latestSwingHigh = oldTabs[selectedTab]["data"][buy]["high"];
                                    break
                                }
                            }
                        }
                        swingValue = latestSwingHigh
                        store.dispatch(setSwing({ index: selectedTab, data: 1, value: Number(swingValue), arrayName: 'advancedIntradayTabs' })) // Swing is HIGH
                    }

                    break;
                }
                prevTrend = latestTrend

                if (currentTrend === prevTrend && i === 0) {
                    let swingIndex = 9;
                    if (currentTrend === "BUY") {
                        // This part will handle if the trend is BUY
                        let latestSwingLow = oldTabs[selectedTab]["data"][swingIndex]["low"];

                        for (var buy = 9; buy >= 0; buy--) {
                            if (latestSwingLow > oldTabs[selectedTab]["data"][buy]["low"]) {
                                latestSwingLow = oldTabs[selectedTab]["data"][buy]["low"];
                            }
            
                            if(buy !== 0) {
                                if(oldTabs[selectedTab]["data"][buy]["low"] < oldTabs[selectedTab]["data"][buy - 1]["low"]) {                  
                                    latestSwingLow = oldTabs[selectedTab]["data"][buy]["low"];
                                    break
                                }
                            }
                        }
            
                        swingValue = latestSwingLow;
                        store.dispatch(setSwing({ 
                            index: selectedTab, data: 2, value: Number(swingValue), arrayName: "advancedIntradayTabs" 
                        })); // Swing is LOW
                    } else if (currentTrend === "SELL") {
                        let latestSwingHigh = oldTabs[selectedTab]["data"][swingIndex]["high"];

                        for (var buy = 9; buy >= 0; buy--) {
                            if (latestSwingHigh < oldTabs[selectedTab]["data"][buy]["high"]) {
                                latestSwingHigh = oldTabs[selectedTab]["data"][buy]["high"];
                            }
            
                            if(buy !== 0) {
                                if(oldTabs[selectedTab]["data"][buy]["high"] > oldTabs[selectedTab]["data"][buy - 1]["high"]) {                  
                                    latestSwingHigh = oldTabs[selectedTab]["data"][buy]["high"];
                                    break
                                }
                            }
                        }
            
                        swingValue = latestSwingHigh;
                        store.dispatch(setSwing({ 
                            index: selectedTab, data: 1, value: Number(swingValue), arrayName: "advancedIntradayTabs" 
                        })); // Swing is HIGH
                    }
                }
            }
        }  else {
            if((whichPhaseIsThis === 1) && (goPrevPhaseValue == false)) {
                store.dispatch(updatePhaseValues({ index: selectedTab, arrayName: "advancedIntradayTabs", data: Number(oldTabs[selectedTab]['data'][9]['close']), phaseName: "downPhasedValues" }))
                swingValue = Number(nextPhaseValue)
                store.dispatch(updateLastCloseValue({ key: "advancedIntradayTabs", index: selectedTab, value: Number(nextPhaseValue) }))

                if(whichPhaseIsThis != oldTabs[selectedTab]['whichPhase']) {
                    store.dispatch(setPhase({ index: selectedTab, arrayName: "advancedIntradayTabs", data: 1 }))
                }
            } else if( (whichPhaseIsThis === 1) && (goPrevPhaseValue == true)) { 
                swingValue = Number(nextPhaseValue)
                store.dispatch(updateLastCloseValue({ key: "advancedIntradayTabs", index: selectedTab, value: Number(nextPhaseValue) }))
                store.dispatch(removeLastElementInPhaseVale({ index: selectedTab, arrayName: "advancedIntradayTabs", phaseName: "downPhasedValues" }))
            } else if(whichPhaseIsThis === 3) {
                swingValue = Number(nextPhaseValue)
                store.dispatch(updateLastCloseValue({ key: "advancedIntradayTabs", index: selectedTab, value: Number(nextPhaseValue) }))
            } else {
                swingValue = oldTabs[selectedTab]['swingVal']
            }
        }

        let log = []
        let log2 = []
        let avgOfLog = 0
        let avgOfLog2 = 0
        let avgOfHigh = 0
        let avgOfLow = 0

        oldTabs[selectedTab]['data'].map((item, index) => {
            if(index === 0) {
                log.push(0)
                log2.push(0)

                avgOfHigh = oldTabs[selectedTab]['data'][index]['high']
                avgOfLow = oldTabs[selectedTab]['data'][index]['low']
            } else {
                let temp = Math.log(oldTabs[selectedTab]['data'][index]['close'] / oldTabs[selectedTab]['data'][index - 1]['close'])
                avgOfHigh = avgOfHigh + oldTabs[selectedTab]['data'][index]['high']
                avgOfLow = avgOfLow + oldTabs[selectedTab]['data'][index]['low']

                avgOfLog = avgOfLog + temp
                log.push(temp.toFixed(6)) 
                avgOfLog2 = avgOfLog2 + (temp * temp)
                log2.push(temp * temp)
            }
        })

        avgOfLog = avgOfLog / 9
        avgOfLog2 = avgOfLog2 / 9

        const latestClose = swingValue

        let variance = avgOfLog2 - avgOfLog * avgOfLog
        let volatality = Math.sqrt(variance) * 100
        let dailyVolatality = volatality * Math.sqrt(365) / 100        
        
        let expRetOne = (dailyVolatality * latestClose * Math.sqrt(1)) / Math.sqrt(365)
        let expRetTwo = (expRetOne / 11) * protectiveFactors[0]['value']        
        
        let buyEntry = latestClose + expRetTwo * newConstants[0]
        let sellEntry = latestClose - expRetTwo * newConstants[0]

        let rsl = ((avgOfHigh / 10) - (avgOfLow / 10)) / 2
        let csl = buyEntry - sellEntry
        let difference = Math.abs(rsl - csl)
        let pf = 0
        let pfKey = ''

        if(oldTabs[selectedTab]['swingType'] == 1) {            
            rsl = rsl / 2;
        }

        if(calculateTrend || (whichPhaseIsThis === 3)) {
            protectiveFactors.map((item, index) => {
                expRetTwo = (expRetOne / 11) * item['value']
                buyEntry = latestClose + expRetTwo * newConstants[0]
                sellEntry = latestClose - expRetTwo * newConstants[0]
                csl = buyEntry - sellEntry
    
                if(Math.abs(rsl - csl) < difference) {
                    pf = item['value']
                    pfKey = item['key']
                    difference = Math.abs(rsl - csl)
                }
            })
        } else {
            pfKey = oldTabs[selectedTab]['additionalDetails'][5]['value']            
            protectiveFactors.map((item) => {
                if(item['key'] === pfKey) {
                    pf = item['value']
                }                
            })
        }

        expRetTwo = (expRetOne / 11) * pf
        buyEntry = latestClose + expRetTwo * newConstants[0]
        sellEntry = latestClose - expRetTwo * newConstants[0]
        csl = buyEntry - sellEntry

        let expectedMovement = csl * 1.2953

        let buyM1 = latestClose + expRetTwo * newConstants[1]
        let sellM1 = latestClose - expRetTwo * newConstants[1]

        let buyM2 = latestClose + expRetTwo * newConstants[2]
        let sellM2 = latestClose - expRetTwo * newConstants[2]

        let buyM3 = latestClose + expRetTwo * newConstants[3]
        let sellM3 = latestClose - expRetTwo * newConstants[3]

        let buyREL = buyEntry - expRetTwo * newConstants[4]
        let sellREL = sellEntry + expRetTwo * newConstants[4]

        let diffREL = sellREL - buyREL

        let confEntryBuy  = buyEntry + constForConfEntryPositional[0] * diffREL
        let confEntrySell = sellEntry - diffREL * constForConfEntryPositional[0]

        let asl = confEntryBuy - confEntrySell

        const targetOne = expectedMovement * 1.338
        const targetTwo = expectedMovement * 2.338

        let targetOneBuy = targetOne + confEntryBuy
        let targetTwoBuy = targetTwo + confEntryBuy

        let targetOneSell = confEntrySell - targetOne
        let targetTwoSell = confEntrySell - targetTwo

        const initPhase = [
            { type: "Entry", buySide: buyEntry.toFixed(2), sellSide: sellEntry.toFixed(2) },
            { type: "Initiate entry upto", buySide: buyM1.toFixed(2), sellSide: sellM1.toFixed(2) },
            { type: "Decision price", buySide: buyM2.toFixed(2), sellSide: sellM2.toFixed(2) },
            { type: "Move to next phase", buySide: buyM3.toFixed(2), sellSide: sellM3.toFixed(2) }
        ]
        
        let updateDB = false;

        if (currentPhase) {
            store.dispatch(updateCurrentPhaseCalc({ index: selectedTab, data: initPhase, key: "advancedIntradayTabs" }));
            
            if (swingType === 1) {
                if (oldTabs[selectedTab]["currentPhase"][3]["sellSide"] > candleData.open.toFixed(2)) {
                    handleCalculate(false, oldTabs[selectedTab]["currentPhase"][3]["sellSide"], 1, false, true, 1, candleData); // 1 Maps to Swing high
                    return;
                }

                updateDB = true;
                store.dispatch(setCandleData({ arrayName: "advancedIntradayTabs", selectedTabIndex: selectedTab, data: candleData }));
            } else {
                if (oldTabs[selectedTab]["currentPhase"][3]["buySide"] < candleData.open.toFixed(2)) {
                    handleCalculate(false, oldTabs[selectedTab]["currentPhase"][3]["buySide"], 1, false, true, 2, candleData); // 2 Maps to Swing low
                    return;
                }

                updateDB = true;
                store.dispatch(setCandleData({arrayName: "advancedIntradayTabs", selectedTabIndex: selectedTab, data: candleData }));
            }
        }

        if (!updateDB) {
            store.dispatch(updateCurrentPhaseCalc({ index: selectedTab, data: initPhase, key: "advancedIntradayTabs" }));
        }
        
        const orderPlaceMentBuy = [
            { key: "Buy range", value: "₹ "+confEntryBuy.toFixed(2)+" to ₹ "+buyM1.toFixed(2) },
            { key: "Pull back entry / TSL", value: "₹ "+confEntrySell.toFixed(2) },
            { key: "Re entry level", value: "₹ "+sellREL.toFixed(2)+" to ₹ "+buyREL.toFixed(2) },
            { key: "Target - 1", value: "₹ "+targetOneBuy.toFixed(2) },
            { key: "Target - 2", value: "₹ "+targetTwoBuy.toFixed(2) },
        ]

        const orderPlaceMentSell = [
            { key: "Sell range", value: "₹ "+confEntrySell.toFixed(2)+" to ₹ "+sellM1.toFixed(2) },
            { key: "Pull back entry / TSL", value: "₹ "+confEntryBuy.toFixed(2) },
            { key: "Re entry level", value: "₹ "+buyREL.toFixed(2)+" to ₹ "+sellREL.toFixed(2) },
            { key: "Target - 1", value: "₹ "+targetOneSell.toFixed(2) },
            { key: "Target - 2", value: "₹ "+targetTwoSell.toFixed(2) },
        ]

        store.dispatch(updateOrderPlacementCalc({ index: selectedTab, data: { "buy": orderPlaceMentBuy, "sell": orderPlaceMentSell }, arrayName: "advancedIntradayTabs" }))

        const additionalDetails = [
            { key: "RSL", value: rsl.toFixed(2) },
            { key: "CSL", value: csl.toFixed(2) },
            { key: "ASL", value: asl.toFixed(2) },
            { key: "EXP.MOV", value: expectedMovement.toFixed(2) },
            { key: "VOLATALITY", value: dailyVolatality.toFixed(2) },
            { key: "PF", value: pfKey }
        ]

        store.dispatch(updateAdditionalDataCalc({ index: selectedTab, data: additionalDetails, arrayName: "advancedIntradayTabs" }))
                
        store.dispatch(onlyDisplayElement({ index: selectedTab, elementName: 'hideInitPhaseDiv', arrayName: "advancedIntradayTabs" }))
        store.dispatch(onlyDisplayElement({ index: selectedTab, elementName: 'orderPlacementDiv', arrayName: "advancedIntradayTabs" }))
        store.dispatch(onlyDisplayElement({ index: selectedTab, elementName: 'additionalDetailsDiv', arrayName: "advancedIntradayTabs" }))
        store.dispatch(onlyDisplayElement({ index: selectedTab, elementName: 'currentPhaseDiv', arrayName: "advancedIntradayTabs" }))        

        setInitPhaseDiv(!hideInitPhaseDiv)

        if (updateDB === false && currentPhase === true) {
            return;
        }
        oldTabs[selectedTab]['endDate'].toString()

        store.dispatch(updateTabDataInDB({ docId: oldTabs[selectedTab]['docId'], docName: 'advancedIntradayTabs', tabDataToUpdate: oldTabs[selectedTab] }))
    }

    const handleSnackBarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackBar(false);
    }

    const handleInstrumentChange = (key) => {
        if(key === null) {
            store.dispatch(setSymbols({ data: symbolsCopy }))
            store.dispatch(instrumentChange({ index: selectedTab, arrayName: "advancedIntradayTabs", data: "" }))
            setInitPhaseDiv(!hideInitPhaseDiv)
            return
        }
        
        let toSetSymbols = []
        for(let i in symbolsCopy) {
            if(key['key'] === symbolsCopy[i]['ty']) {
                toSetSymbols.push(symbolsCopy[i])
            }
        }

        if(instruments.indexOf(key) !== oldTabs[selectedTab]['inst']) {
            store.dispatch(changeSymbol({ index: selectedTab, arrayName: "advancedIntradayTabs", data: "" }))
        }
      
        store.dispatch(setSymbols({ data: toSetSymbols }))
        store.dispatch(instrumentChange({ index: selectedTab, arrayName: "advancedIntradayTabs", data: instruments.indexOf(key) }))
          
        if(key['key'] === 'fut') {
            store.dispatch(expiryChange({ index: selectedTab, arrayName: "advancedIntradayTabs", data: expiryMonths[0] }))
        }

        setInitPhaseDiv(!hideInitPhaseDiv)
    }

    const handleExchangeChange = (key) => {
        if(key) {
            store.dispatch(exchangeChange({ index: selectedTab, arrayName: "advancedIntradayTabs", data: key }))
            setInitPhaseDiv(!hideInitPhaseDiv)
        }
    }

    const handleSymbolChange = (key) => {
        if(key !== undefined) {
            store.dispatch(changeSymbol({ index: selectedTab, arrayName: "advancedIntradayTabs", data: key }))
            store.dispatch(changeCaptionName({ index: selectedTab, arrayName: "advancedIntradayTabs",data: key }));

            setInitPhaseDiv(!hideInitPhaseDiv)
        }
    }

    const handleEndDateChange = (key) => {
        if(key){
            store.dispatch(changeEndDate({ index: selectedTab, arrayName: "advancedIntradayTabs", data: key.toString() }))
            setInitPhaseDiv(!hideInitPhaseDiv)
        }
    }

    const handleCaptionChange = (key) => {
        if(key) {
            store.dispatch(changeCaptionName({ index: selectedTab, arrayName: "advancedIntradayTabs", data: key }))
            setInitPhaseDiv(!hideInitPhaseDiv)
        }
    }

    const handleBack = () => {
        let swingValue = 0

        if( oldTabs[selectedTab]['whichPhase'] == 0 ) {
            swingValue = oldTabs[selectedTab]['upPhasedValues'][Number(oldTabs[selectedTab]['upPhasedValues'].length) - 1]
        } else if( oldTabs[selectedTab]['whichPhase'] == 1 ) {
            swingValue = oldTabs[selectedTab]['downPhasedValues'][oldTabs[selectedTab]['downPhasedValues'].length - 1]
        }

        handleCalculate(false, Number(swingValue), oldTabs[selectedTab]['whichPhase'], true)        
    }

    const handleManualDataPushInputField = (key) => {
        let dataObj = {}
        let dataArray = []

        key.split(" ").map(item => {
            let key = item.split('\t')
            dataObj['date'] = key[0]
            dataObj['open'] = Number(key[1])
            dataObj['high'] = Number(key[2])
            dataObj['low'] = Number(key[3])
            dataObj['close'] = Number(key[4])
            dataArray.push(dataObj)
            dataObj = {}
        })

        dataArray.map((item, index) => {
            if(isNaN(item['open'])) {
                dataArray[index]['open'] = 0
                dataArray[index]['high'] = 0
                dataArray[index]['low'] = 0
            }
        })

        if(oldTabs[selectedTab]['swing'] !== 0) {            
            store.dispatch(updateInitPhaseCalc({ index: selectedTab, data: [], arrayName: "advancedIntradayTabs" }))
            store.dispatch(updateCurrentPhaseCalc({ index: selectedTab, data: [], key: 'advancedIntradayTabs' }))

            store.dispatch(updateOrderPlacementCalc({ index: selectedTab, data: { "buy": [], "sell": [] }, arrayName: "advancedIntradayTabs"}))
            store.dispatch(updateAdditionalDataCalc({ index: selectedTab, data: [], arrayName: "advancedIntradayTabs" }))

            store.dispatch(setSwing({ index: selectedTab, data: 0, value: 0, arrayName: 'advancedIntradayTabs' }))
        }

        setTimeout(() => {
            store.dispatch(pushStockData({ index: selectedTab, arrayName: "advancedIntradayTabs", data: dataArray }))

            store.dispatch(onlyDisplayElement({ index: selectedTab, elementName: 'hideDataDiv', arrayName: "advancedIntradayTabs" }))
            store.dispatch(hideOrDisplayElement({ index: selectedTab, elementName: 'hideSelectForm', arrayName: "advancedIntradayTabs" }))
            setInitPhaseDiv(!hideInitPhaseDiv)

            const key = oldTabs[selectedTab]
            let dataToUpdate = {
                labelName: key['labelName'],
                exchange: key['exchange'],                
                symbol:key['symbol'],                
                interval: key["interval"],
                endDate: key['endDate'].toString(),
                endTime: key['endTime'],
                inst: key['inst'],
                expiry: key['expiry'],
                isDataFromManual: true,

                swing: key['swing'],
                swingVal: key['swingVal'],
                swingType: key['swingType'],
                
                data: key['data'],
                initPhase: key['initPhase'],
                currentPhase: key['currentPhase'],
                orderPlaceMentBuy: key['orderPlaceMentBuy'],
                orderPlaceMentSell: key['orderPlaceMentSell'],
                additionalDetails: key['additionalDetails'],
                hideSelectForm: key['hideSelectForm'],
                hideDataDiv: key['hideDataDiv'],
                hideInitPhaseDiv: key['hideInitPhaseDiv'],
                orderPlacementDiv: key['orderPlacementDiv'],
                currentPhaseDiv: key['currentPhaseDiv'],
                additionalDetailsDiv: key['additionalDetailsDiv'],

                upPhasedValues: key["upPhasedValues"],
                downPhasedValues: key["downPhasedValues"],
                whichPhase: key["whichPhase"]
            }
    
            store.dispatch(updateTabDataInDB({ docId: oldTabs[selectedTab]['docId'], docName: 'advancedIntradayTabs', tabDataToUpdate: dataToUpdate }))
        }, 500);
    }

    const handleSubmitSwingValueForm = (e) => {
        e.preventDefault()
        const form = new FormData(e.target)
        if(form.get('swingvalue') == "") {            
            setTimeout(() => {
                handleCalculate(false, Number(oldTabs[selectedTab]['swingVal']), 3)
            }, 200);

            return;
        }

        handleCalculate(false, Number(form.get('swingvalue')), 3)
    }

    const handleAddNewTab = () => {
        setInitPhaseDiv(!hideInitPhaseDiv)
        console.log('Chk', hideInitPhaseDiv)

        const structureForAdvancedIntrady = {
            labelName: "New tab",
            exchange: "NSE",
            symbol: "",
            interval: "",
            endDate: "",
            inst: "",
            expiry: "",
            endTime: "",

            isDataFromManual: false,
            
            swing: 0,
            swingVal: 0.0,
            swingType: 0,
            candleData: {},
          
            data: [],
            initPhase: [],
            currentPhase: [],
            orderPlaceMentBuy: [],
            orderPlaceMentSell: [],
            additionalDetails: [],
            initialLastCloseValue: 0,
            
            hideSelectForm: false,
            hideDataDiv: true,
            hideInitPhaseDiv: true,
            orderPlacementDiv: true,
            currentPhaseDiv: true,
            additionalDetailsDiv: true,
            hideStoplossAndTargets: true,
            notify: false,
          
            upPhasedValues: [],
            downPhasedValues: [],
            whichPhase: ''
        }

        store.dispatch(addNewTab({ arrayName: 'advancedIntradayTabs', selectedTabName: 'advancedIntradaySelectedTab', data: structureForAdvancedIntrady }))
        setInitPhaseDiv(!hideInitPhaseDiv)
        console.log('Chk', hideInitPhaseDiv)
    }

    const deleteTab = (index) => {        
        store.dispatch(handleDeleteTab({ tabIndex: index, arrayName: 'advancedIntradayTabs', selectedTabName: 'advancedIntradaySelectedTab', docId: oldTabs[index]['docId'] }))        
        setInitPhaseDiv(!hideInitPhaseDiv)
    }

    const handleEndTime = (key) => {
        store.dispatch(changeEndTime({ index: selectedTab, arrayName: "advancedIntradayTabs", data: key }))
        setInitPhaseDiv(!hideInitPhaseDiv)
    }

    const handleSwingType = (key) => {
        if(swingTypes.indexOf(key)  === 1) {
            store.dispatch(changeSwingType({ index: selectedTab, arrayName: "advancedIntradayTabs", data: swingTypes.indexOf(key) }))
            store.dispatch(updateLastCloseValue({ key: "advancedIntradayTabs", index: selectedTab, value: Number(oldTabs[selectedTab]['initialLastCloseValue']) }))

            handleCalculate(true, 0);
        } else {
            store.dispatch(changeSwingType({ index: selectedTab, arrayName: "advancedIntradayTabs", data: swingTypes.indexOf(key) }))
            store.dispatch(updateLastCloseValue({ key: "advancedIntradayTabs", index: selectedTab, value: Number(oldTabs[selectedTab]['initialLastCloseValue']) }))

            handleCalculate(true, 0);
        }
        setInitPhaseDiv(!hideInitPhaseDiv)
    }

    const handleInterval = (key) => {
        store.dispatch(changeInterval({ index: selectedTab, arrayName: "advancedIntradayTabs", value: key }))
        setInitPhaseDiv(!hideInitPhaseDiv)
    }

    const isObjectEmpty = (objectData) => {
        for(let keys in objectData) {
            return false
        }
        return true
    }

    const handleExpiryChange  = (key) => {
        store.dispatch(expiryChange({ index: selectedTab, arrayName: "advancedIntradayTabs", data: key }))
        setInitPhaseDiv(!hideInitPhaseDiv)
    }

    function getTwoPlainAndNonInsiderCandle(heikinAshiData, normalData, swingType) {
        let firstCandleRefData = { low: 0.5, open: 1.0, close: 0.8, high: 0 };
        let plainAndNonInsiderCandle = '';
        let secondPlainAndNonInsiderCandle = '';

        for (let i = 0; i < heikinAshiData.length; i++) {
            if ((heikinAshiData[i]['low'] < firstCandleRefData['low']) || (heikinAshiData[i]['high'] > firstCandleRefData['high'])) {
                firstCandleRefData = heikinAshiData[i];

                if (firstCandleRefData['open'] === firstCandleRefData[swingType]) {
                    if (swingType === "low") {
                        if (heikinAshiData[i]['close'] < normalData[i]['close']) {
                            if (firstCandleRefData[swingType] > Number(oldTabs[selectedTab]["currentPhase"][3]["buySide"])) {
                                plainAndNonInsiderCandle = heikinAshiData[i];

                                // This loop to get possbile second candle...
                                for (let j = i; j < heikinAshiData.length; j++) { 
                                    if ((heikinAshiData[j]['low'] < firstCandleRefData['low']) || (heikinAshiData[j]['high'] > firstCandleRefData['high'])) {
                                        if (firstCandleRefData['open'] === firstCandleRefData[swingType]) {
                                            if (heikinAshiData[j]['close'] < normalData[j]['close']) {
                                                secondPlainAndNonInsiderCandle = heikinAshiData[j];
    
                                                if (secondPlainAndNonInsiderCandle[swingType] > Number(oldTabs[selectedTab]["currentPhase"][3]["buySide"])) {
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                    firstCandleRefData = heikinAshiData[j];
                                }
                                break;
                            }
                        }
                    }

                    if (swingType === "high") {
                        if (heikinAshiData[i]['close'] > normalData[i]['close']) {
                            if (firstCandleRefData[swingType] < Number(oldTabs[selectedTab]["currentPhase"][3]["sellSide"])) {
                                plainAndNonInsiderCandle = heikinAshiData[i];

                                // This loop to get possbile second candle...
                                for (let j = i; j < heikinAshiData.length; j++) { 
                                    if ((heikinAshiData[j]['low'] < firstCandleRefData['low']) || (heikinAshiData[j]['high'] > firstCandleRefData['high'])) {
                                        if (firstCandleRefData['open'] === firstCandleRefData[swingType]) {
                                            if (heikinAshiData[j]['close'] > normalData[j]['close']) {
                                                secondPlainAndNonInsiderCandle = heikinAshiData[j];
    
                                                if (secondPlainAndNonInsiderCandle[swingType] < Number(oldTabs[selectedTab]["currentPhase"][3]["sellSide"])) {
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                    firstCandleRefData = heikinAshiData[j];
                                }
                                break;
                            }
                        }
                    }
                }
            }
        }

        if (plainAndNonInsiderCandle != '' && secondPlainAndNonInsiderCandle != '') {
            return {
                plainAndNonInsiderCandle: plainAndNonInsiderCandle,
                secondPlainAndNonInsiderCandle: secondPlainAndNonInsiderCandle
            }
        }

        return 'noCandle';
    }

    function getPlainAndNonInsiderCandle(heikinAshiData, normalData, swingType, loopBreak) {
        let firstCandleRefData = { low: 0.5, open: 1.0, close: 0.8, high: 0 };
        let plainAndNonInsiderCandle = '';
        let returnMessage = '1';

        const returnMesageContent = {
            "1": "There is no plain & non-insider candle.",
            "2": "There is some plain & non-insider candles, but the candle open value didn't break the current phase buy / sell side value"
        }

        for (let i = 0; i < heikinAshiData.length; i++) {
            if ((heikinAshiData[i]['low'] < firstCandleRefData['low']) || (heikinAshiData[i]['high'] > firstCandleRefData['high'])) {
                firstCandleRefData = heikinAshiData[i];
                if (firstCandleRefData['open'] === firstCandleRefData[swingType]) {
                    returnMessage = "2"
                    if (swingType === "low") {
                        if (firstCandleRefData['open'] > Number(oldTabs[selectedTab]["currentPhase"][3]["buySide"])) {
                            if (heikinAshiData[i]['close'] < normalData[i]['close']) {
                                plainAndNonInsiderCandle = heikinAshiData[i];
                                if(loopBreak) {
                                    break;
                                }
                            }
                        }
                    }

                    if (swingType === "high") {
                        if (firstCandleRefData['open'] < Number(oldTabs[selectedTab]["currentPhase"][3]["sellSide"])) {
                            if (heikinAshiData[i]['close'] > normalData[i]['close']) {
                                plainAndNonInsiderCandle = heikinAshiData[i];
                                if(loopBreak) {
                                    break;
                                }
                            }
                        }
                    }
                }
            }
        }

        return {
            returnMessage: returnMesageContent[returnMessage],
            candleData: plainAndNonInsiderCandle
        }
    }

    const setCandleDataAndChangePhaseForSwingLow = (data) => {
        if (data["open"] > oldTabs[selectedTab]["currentPhase"][3]["buySide"] ) {
            handleCalculate( false, oldTabs[selectedTab]["currentPhase"][3]["buySide"], 1, false, true, 2, data)
        } else {
            store.dispatch(setCandleData({
                arrayName: "advancedIntradayTabs",
                selectedTabIndex: selectedTab,
                data: data
            }))

            setInitPhaseDiv(!hideInitPhaseDiv)
        }
    }

    const setCandleDataAndChangePhaseForSwingHigh = (data) => {
        if (data["open"] < oldTabs[selectedTab]["currentPhase"][3]["sellSide"]) {
          handleCalculate(false, oldTabs[selectedTab]["currentPhase"][3]["sellSide"], 1, false, true, 1, data)
        } else {
          store.dispatch(setCandleData({
            arrayName: "advancedIntradayTabs",
            selectedTabIndex: selectedTab,
            data: data
          }))
          setInitPhaseDiv(!hideInitPhaseDiv)
        }
    }

    const handleCalculateCurrentPhase = (swingType) => {
        for(var i = 9; i >= 0; i--) {
            if(oldTabs[selectedTab]['data'][i][swingType] == oldTabs[selectedTab]['swingVal']) {
                let fromAndToDate = {}
                fromAndToDate = getResDatesForAPICall(oldTabs[selectedTab]["data"][i]["date"], new Date());

                let symbol = oldTabs[selectedTab]["symbol"]
                let currentDate = new Date()
                if(oldTabs[selectedTab]["inst"] === 1) {
                    symbol = symbol + addZeroPrefixInString(currentDate.getFullYear().toString()[2] + currentDate.getFullYear().toString()[3]) + oldTabs[selectedTab]["expiry"] + "FUT"
                }

                fetchDataFromAPIReturnHeikinAshiValue(symbol, fromAndToDate["fromDate"], fromAndToDate["toDate"], "", "15min", false,
                    function (heikinAshiData, normalData) {
                        if(oldTabs[selectedTab]['interval'] === '15mins') {
                            let candle = getTwoPlainAndNonInsiderCandle(heikinAshiData, normalData, swingType, true)
                            if (candle !== 'noCandle') {
                                candle.plainAndNonInsiderCandle['secondPlainAndNonInsiderCandleDate'] = candle.secondPlainAndNonInsiderCandle.date

                                if (swingType === 'low') {
                                    setCandleDataAndChangePhaseForSwingLow(candle.plainAndNonInsiderCandle)
                                } else if (swingType === 'high') {
                                    setCandleDataAndChangePhaseForSwingHigh(candle.plainAndNonInsiderCandle)
                                }
                            } else {
                                alert("There are no plain & non insider candles...")
                            }
                        } else if(oldTabs[selectedTab]['interval'] === '30mins') {
                            let obj = {}
                            let stockData = []

                            // Converting 15mins candle data to 30mins...
                            for(let i = 0; i < normalData.length; i = i + 25) {
                                for(let j = i; j < i + 25; j = j + 2) {
                                    if(j < normalData.length) {
                                        if(normalData[j]['date'].split("T")[1] !== "15:15:00") {
                                            obj = {
                                                date: normalData[j]['date'],
                                                open: normalData[j]['open'],
                                                high: normalData[j]['high'] > normalData[j + 1]['high'] ? normalData[j]['high'] : normalData[j + 1]['high'],
                                                low: normalData[j]['low'] < normalData[j + 1]['low'] ? normalData[j]['low'] : normalData[j + 1]['low'],
                                                close: normalData[j + 1]['close']
                                            }
                                            stockData.push(obj)
                                            obj = {}
                                        }
                                    }
                                }
                            }

                            heikinAshiData = []
                            let normalDataStockData = []
                            let heikinAshiOpen = 0
                            let heikinAshiHigh = 0
                            let heikinAshiLow = 0
                            let heikinAshiClose = 0

                            for(let i = 0; i < stockData.length; i++) {
                                if(stockData[i]['date'] >= oldTabs[selectedTab]['data'][9]['date']) {
                                    normalDataStockData.push({
                                        'date': stockData[i]['date'],
                                        'open': stockData[i]['open'],
                                        'high': stockData[i]['high'],
                                        'low': stockData[i]['low'],
                                        'close': stockData[i]['close']
                                    })
                                }
                            }

                            for(let i = 0; i < stockData.length; i++) {
                                if(i === 0) {
                                    heikinAshiOpen = Number(stockData[i]['open'])
                                    heikinAshiClose = ( Number(stockData[i]['open']) + Number(stockData[i]['high']) + Number(stockData[i]['low']) + Number(stockData[i]['close']) ) / 4
                                    heikinAshiHigh = higestValue([heikinAshiOpen, Number(stockData[i]['high']), heikinAshiClose], 2)
                                    heikinAshiLow = lowestValue([heikinAshiOpen, Number(stockData[i]['low']), heikinAshiClose], 2)
                                    stockData[i]['close'] = heikinAshiClose
                                } else {
                                    heikinAshiOpen = ( Number(stockData[i - 1]['open']) + Number(stockData[i - 1]['close']) ) / 2
                                    heikinAshiClose = ( Number(stockData[i]['open']) + Number(stockData[i]['high']) + Number(stockData[i]['low']) + Number(stockData[i]['close']) ) / 4
                                    stockData[i]['open'] = heikinAshiOpen
                                    stockData[i]['close'] = heikinAshiClose
                                    heikinAshiHigh = higestValue([heikinAshiOpen, Number(stockData[i]['high']), heikinAshiClose], 2)
                                    heikinAshiLow = lowestValue([heikinAshiOpen, Number(stockData[i]['low']), heikinAshiClose], 2)
                                }

                                if(stockData[i]['date'] >= oldTabs[selectedTab]['data'][9]['date']) {
                                    heikinAshiData.push({
                                        'date': stockData[i]['date'],
                                        'open': heikinAshiOpen,
                                        'high': heikinAshiHigh,
                                        'low': heikinAshiLow,
                                        'close': heikinAshiClose
                                    })
                                }
                            }

                            if (heikinAshiData.length >= 11) {
                                let getPlainAndNonInsiderCandleResponse = getPlainAndNonInsiderCandle(heikinAshiData.slice(0, 12), normalDataStockData.slice(0, 12), swingType, false);

                                if(getPlainAndNonInsiderCandleResponse.candleData !== '') {
                                    if(swingType === 'high') {
                                        setCandleDataAndChangePhaseForSwingHigh(getPlainAndNonInsiderCandleResponse.candleData)
                                    } else if(swingType === 'low') {
                                        setCandleDataAndChangePhaseForSwingLow(getPlainAndNonInsiderCandleResponse.candleData)
                                    }
                                } else {
                                    setSnackMessage(getPlainAndNonInsiderCandleResponse.returnMessage);
                                    setSnackStatus("info");
                                    setSnackBar(true);
                                }
                            } else {
                                setSnackMessage("There is very few possible candles");
                                setSnackStatus("info");
                                setSnackBar(true);
                            }
                        } else if(oldTabs[selectedTab]['interval'] === '60mins') {
                            let obj = {}
                            let stockData = []

                            // Converting 15mins candle data to 30mins...
                            for(let i = 0; i < normalData.length; i = i + 25) {
                                for(let j = i; j < i + 25; j = j + 4) {
                                    if(j < normalData.length) {
                                        if(normalData[j]['date'].split("T")[1] !== "15:15:00") {
                                            obj = {
                                                date: normalData[j]['date'],
                                                open: normalData[j]['open'],
                                                high: higestValue([normalData[j]['high'], normalData[j + 1]['high'], normalData[j + 2]['high'], normalData[j + 3]['high']], 3),
                                                low: lowestValue([normalData[j]['low'], normalData[j + 1]['low'], normalData[j + 2]['low'], normalData[j + 3]['low']], 3),
                                                close: normalData[j + 3]['close']
                                            }
                                            stockData.push(obj)
                                            obj = {}
                                        }
                                    }
                                }
                            }

                            heikinAshiData = []
                            let normalDataStockData = []
                            let heikinAshiOpen = 0
                            let heikinAshiHigh = 0
                            let heikinAshiLow = 0
                            let heikinAshiClose = 0

                            for(let i = 0; i < stockData.length; i++) {
                                if(stockData[i]['date'] >= oldTabs[selectedTab]['data'][9]['date']) {
                                    normalDataStockData.push({
                                        'date': stockData[i]['date'],
                                        'open': stockData[i]['open'],
                                        'high': stockData[i]['high'],
                                        'low': stockData[i]['low'],
                                        'close': stockData[i]['close']
                                    })
                                }
                            }

                            for(let i = 0; i < stockData.length; i++) {
                                if(i === 0) {
                                    heikinAshiOpen = Number(stockData[i]['open'])
                                    heikinAshiClose = ( Number(stockData[i]['open']) + Number(stockData[i]['high']) + Number(stockData[i]['low']) + Number(stockData[i]['close']) ) / 4
                                    heikinAshiHigh = higestValue([heikinAshiOpen, Number(stockData[i]['high']), heikinAshiClose], 2)
                                    heikinAshiLow = lowestValue([heikinAshiOpen, Number(stockData[i]['low']), heikinAshiClose], 2)
                                    stockData[i]['close'] = heikinAshiClose
                                } else {
                                    heikinAshiOpen = ( Number(stockData[i - 1]['open']) + Number(stockData[i - 1]['close']) ) / 2
                                    heikinAshiClose = ( Number(stockData[i]['open']) + Number(stockData[i]['high']) + Number(stockData[i]['low']) + Number(stockData[i]['close']) ) / 4
                                    stockData[i]['open'] = heikinAshiOpen
                                    stockData[i]['close'] = heikinAshiClose
                                    heikinAshiHigh = higestValue([heikinAshiOpen, Number(stockData[i]['high']), heikinAshiClose], 2)
                                    heikinAshiLow = lowestValue([heikinAshiOpen, Number(stockData[i]['low']), heikinAshiClose], 2)
                                }

                                if(stockData[i]['date'] >= oldTabs[selectedTab]['data'][9]['date']) {
                                    heikinAshiData.push({
                                        'date': stockData[i]['date'],
                                        'open': heikinAshiOpen,
                                        'high': heikinAshiHigh,
                                        'low': heikinAshiLow,
                                        'close': heikinAshiClose
                                    })
                                }
                            }

                            console.log('Chk', heikinAshiData.slice(0, 7))

                            if (heikinAshiData.length >= 6) {
                                let getPlainAndNonInsiderCandleResponse = getPlainAndNonInsiderCandle(heikinAshiData.slice(0, 7), normalDataStockData.slice(0, 7), swingType, false);
                                console.log('Chk', getPlainAndNonInsiderCandleResponse);

                                if(getPlainAndNonInsiderCandleResponse.candleData !== '') {
                                    if(swingType === 'high') {
                                        setCandleDataAndChangePhaseForSwingHigh(getPlainAndNonInsiderCandleResponse.candleData)
                                    } else if(swingType === 'low') {
                                        setCandleDataAndChangePhaseForSwingLow(getPlainAndNonInsiderCandleResponse.candleData)
                                    }
                                } else {
                                    setSnackMessage(getPlainAndNonInsiderCandleResponse.returnMessage);
                                    setSnackStatus("info");
                                    setSnackBar(true);
                                }
                            } else {
                                setSnackMessage("There is very few possible candles");
                                setSnackStatus("info");
                                setSnackBar(true);
                            }
                        }
                    }
                );

                break;
            }
        }
    }

    const getResDatesForAPICall = (fromDateKey, toDateKey) => {
        let fromDate = new Date(fromDateKey);
        fromDate.setDate(fromDate.getDate() - 10);

        let fromDateYear = fromDate.getFullYear().toString()[2] + fromDate.getFullYear().toString()[3];
        let fromDateMonth = (fromDate.getMonth() + 1).toString();
        let fromDateDay = fromDate.getDate().toString();
    
        fromDate = addZeroPrefixInString(fromDateYear) + addZeroPrefixInString(fromDateMonth) + addZeroPrefixInString(fromDateDay) + "T09:15:00";

        let toDateYear = toDateKey.getFullYear().toString()[2] + toDateKey.getFullYear().toString()[3];
        let toDateMonth = (toDateKey.getMonth() + 1).toString();
        let toDateDay = toDateKey.getDate().toString();
    
        let toDate = addZeroPrefixInString(toDateYear) + addZeroPrefixInString(toDateMonth) + addZeroPrefixInString(toDateDay) + "T15:15:00";

        return { fromDate, toDate }
    }

    return (
        <div style={{ width: "100%", height: "100%", marginTop: 40, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }} >
        {isSmallScreen && <Typography 
            gutterBottom
            variant="h5"
            style={{ padding: 10, paddingTop: 0, fontWeight: 'bold', overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}
            >
                Advanced Intraday
            </Typography>
        }
        { oldTabs.length > 0 ? <div style={{ width: "93%" }} >
            <div style={{ display: 'flex', marginBottom: 30, width: "100%" , flexWrap: "wrap"}} >
                {oldTabs.map((item, index) =>
                    <div style={{ borderRadius:5, display: 'flex', alignItems: 'center', color: selectedTab === index ? darkMode ? selectedTabColorsInDarkMode : selectedTabColorsInLightMode : darkMode ? tabColorsInDarkMode : tabColorsInLightMode, cursor: 'pointer' }} >              
                        <Typography variant="title" style={{ marginRight: 0, padding: 10,overflow:"hidden", textOverflow:"ellipsis",whiteSpace:"nowrap", width : "75%" }} onClick={()=> handleChangeTabs(index)} >
                            {item.labelName}
                        </Typography>
                        {(oldTabs.length > 1 && index !==0) && <ClearOutlined fontSize={'small'} style={{ padding: 10 }} onClick={()=> deleteTab(index)} />}
                    </div>
                )}
                <div style={{ borderRadius:5, display: 'flex', alignItems: 'center', alignItems: 'center', color: darkMode ? selectedTabColorsInDarkMode : selectedTabColorsInLightMode, flex: 1, justifyContent: 'flex-end' }} >
                    <Typography onClick={handleAddNewTab} variant="title" style={{ marginRight: 0, padding: 10, display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                        Add new &nbsp; <AddIcon fontSize={'small'} />
                    </Typography>
                </div>
            </div>

            {/* SELECT FORM START */}
            <div style={{ width: "100%", border: "1px solid rgba(0,0,0,0.3)", borderColor: darkMode ? allBorderColorsInDarkMode : allBorderColorsInLightMode, borderRadius: 5, height: 'auto', marginBottom: 30 }} >
                <div 
                    style={{ margin: 15, display: 'flex', alignItems: 'center', cursor: "pointer"  }} 
                    onClick={()=> handleHideElement('hideSelectForm')} 
                >
                    <text style={{ fontWeight: 500, fontSize: 'large', flex: 1, color: darkMode ? sideHeadingColor : 'black' }} > SELECT FORM </text>
                    {oldTabs[selectedTab]['hideSelectForm'] ?
                        <ExpandMoreIcon style={{ padding: 5, cursor: 'pointer' }}  /> :
                        <ExpandLessIcon style={{ padding: 5, cursor: 'pointer' }}  />
                    }
                </div>

                {oldTabs[selectedTab]['hideSelectForm'] ? "" : <div style={isSmallScreen ? { width: "100%", margin: "30px auto", display: 'flex', marginBottom: 10, flexWrap: 'wrap', justifyContent: 'center' } : { width: "95%", margin: "30px auto", display: 'flex', flexWrap: 'wrap', justifyContent: "space-between", marginBottom: 10 }} >
                    <Autocomplete
                        id="selectExchange"
                        options={exchanges}
                        disabled
                        value={oldTabs[selectedTab]['exchange']}
                        getOptionLabel={(option) => option }
                        onChange={(e, val) => handleExchangeChange(val)}
                        style={{ width: isSmallScreen ? "70%" : 220, maxWidth: 300 ,  margin: 10 }}
                        renderInput={(params) => 
                            darkMode ? <CssTextField {...params} size="small" label="Exchange" variant="outlined" /> :
                            <TextField {...params} size="small" label="Exchange" variant="outlined" />
                        }
                    />
                    <Autocomplete
                        id="selectInst"
                        options={instruments}
                        value={instruments[oldTabs[selectedTab]['inst']]}
                        getOptionLabel={(option) => option.name}
                        onChange={(e, val)=> handleInstrumentChange(val)}
                        style={{ width: isSmallScreen ? "70%" : 220, maxWidth: 300,  margin: 10 }}
                        renderInput={(params) =>
                            darkMode ? <CssTextField {...params} size="small" label="Instrument" variant="outlined" /> :
                            <TextField {...params} size="small" label="Instrument" variant="outlined" />
                        }
                    />
                    {oldTabs[selectedTab]['inst'] == 1 && <Autocomplete
                        id="selectInst"
                        options={expiryMonths}
                        value={oldTabs[selectedTab]['expiry']}
                        getOptionLabel={(option) => option}
                        onChange={(e, val)=> handleExpiryChange(val)}
                        style={{ width: isSmallScreen ? "70%" : 220, maxWidth: 300,  margin: 10 }}
                        renderInput={(params) =>
                            darkMode ? <CssTextField {...params} size="small" label="Expiry" variant="outlined" /> :
                            <TextField {...params} size="small" label="Expiry" variant="outlined" />
                        }
                    />}
                    {
                        oldTabs[selectedTab]['inst'] ==  2 ? 
                            darkMode ? 
                                <CssTextField
                                    id="Symbol"
                                    label="Symbol"
                                    type="text"
                                    value={oldTabs[selectedTab]['symbol']}
                                    size="small"
                                    onChange={(e) => handleSymbolChange(e.target.value)}
                                    variant="outlined"
                                    style={{ width: isSmallScreen ? "70%" : 220, maxWidth: 300, margin: 10 }}                        
                                /> : 
                                <TextField
                                    id="Symbol"
                                    label="Symbol"
                                    type="text"
                                    value={oldTabs[selectedTab]['symbol']}
                                    size="small"
                                    onChange={(e) => handleSymbolChange(e.target.value)}
                                    variant="outlined"
                                    style={{ width: isSmallScreen ? "70%" : 220, maxWidth: 300, margin: 10 }}                        
                                />
                            :
                            <Autocomplete
                                id="selectSymbol"
                                options={symbols}
                                onChange={(e, val) => handleSymbolChange(val.sym)}
                                getOptionLabel={ (option) => option.sym }
                                value={{sym: oldTabs[selectedTab]['symbol']}}
                                style={{ width: isSmallScreen ? "70%" : 220, maxWidth: 300,  margin: 10 }}
                                renderInput={(params) =>
                                    darkMode ? <CssTextField {...params} size="small" label="Symbol" variant="outlined" /> :
                                    <TextField {...params} size="small" label="Symbol" variant="outlined" />
                                }
                            />
                    }
                    <Autocomplete
                        id="interval"
                        options={candleIntervals}
                        onChange={ (e, val) => handleInterval(val) }
                        getOptionLabel={ (option) => option }
                        value={oldTabs[selectedTab]['interval']}
                        style={{ width: isSmallScreen ? "70%" : 220, maxWidth: 300, margin: 10 }}
                        renderInput={(params) =>
                            darkMode ? <CssTextField {...params} size="small" label="Intervals" variant="outlined" /> :
                            <TextField {...params} size="small" label="Intervals" variant="outlined" />
                        }
                    />
                    <Autocomplete
                        id="endTime"
                        options={timeIntervals}
                        onChange={ (e, val) => handleEndTime(val) }
                        getOptionLabel={ (option) => option }
                        value={oldTabs[selectedTab]['endTime']}
                        style={{ width: isSmallScreen ? "70%" : 220, maxWidth: 300, margin: 10 }}
                        renderInput={(params) =>
                            darkMode ? <CssTextField {...params} size="small" label="End time" variant="outlined" /> :
                            <TextField {...params} size="small" label="End time" variant="outlined" />
                        }
                    />
                    {darkMode ? (
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <CssCalendarField
                            variant="inline"
                            format="dd-MM-yyyy"
                            value={oldTabs[selectedTab]["endDate"]}
                            inputVariant="outlined"
                            style={{
                                width: isSmallScreen ? "70%" : 220,
                                maxWidth: 300,
                                margin: 10,
                            }}
                            onChange={handleEndDateChange}
                            // label="End date"
                            />
                        </MuiPickersUtilsProvider>
                        ) : (
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <CssLightCalendarField
                            value={oldTabs[selectedTab]["endDate"]}
                            label="End date"
                            format="dd-MM-yyyy"
                            inputVariant="outlined"
                            style={{
                                width: isSmallScreen ? "70%" : 220,
                                maxWidth: 300,
                                margin: 10,
                            }}
                            variant="inline"
                            onChange={handleEndDateChange}
                            />
                        </MuiPickersUtilsProvider>
                    )}
                    {darkMode ? <CssTextField                             
                            id="caption"
                            label="Caption"
                            type="text"
                            value={oldTabs[selectedTab]['labelName']}
                            size="small"
                            onChange={(e) => handleCaptionChange(e.target.value)}
                            variant="outlined"
                            style={{ width: isSmallScreen ? "70%" : 220, maxWidth: 300, margin: 10 }}                        
                        /> : 
                        <TextField
                            id="caption"
                            label="Caption"
                            type="text"
                            value={oldTabs[selectedTab]['labelName']}
                            size="small"
                            onChange={(e) => handleCaptionChange(e.target.value)}
                            variant="outlined"
                            style={{ width: isSmallScreen ? "70%" : 220, maxWidth: 300, margin: 10 }}                        
                        /> 
                    }
                </div>}
                {oldTabs[selectedTab]['hideSelectForm'] ? "" : 
                    <div style={ isSmallScreen ? { display: 'flex', justifyContent: 'center', width: "100%", marginBottom: 20 } : { display: 'flex', justifyContent: 'flex-end', width: "98%", marginBottom: 20 }} >
                        {darkMode ?
                                <CssTextField
                                    onChange={(e) => handleManualDataPushInputField(e.target.value)}
                                    variant="outlined"
                                    style={{ width: isSmallScreen ? "70%" : 220, maxWidth: 300, margin: 10 }}
                                    id="manuaalDataFeed"
                                    label="Manual input"
                                    type="text"
                                    size="small"
                                    disabled={oldTabs[selectedTab]['labelName'] == ""}
                                /> :
                                <TextField
                                    id="manuaalDataFeed"
                                    label="Manual input"
                                    type="text"
                                    size="small"
                                    disabled={oldTabs[selectedTab]['labelName'] == ""}
                                    onChange={(e) => handleManualDataPushInputField(e.target.value)}
                                    variant="outlined"
                                    style={{ width: isSmallScreen ? "70%" : 220, maxWidth: 300, margin: 10 }}                        
                                />
                            }  
                        <Button onClick={()=> handleSelectForm(selectedTab)} variant="contained" color='primary' size="medium" style={{ width: isSmallScreen ? "70%" : 220, maxWidth: 300, margin: 10 }} >
                            Get DATA
                        </Button>
                    </div>
                }
            </div>
            {/* SELECT FORM END */}
            
            {/* DATA_TABLE_DIV_ST */}
            <div style={{ width: "100%", border: "1px solid rgba(0,0,0,0.3) ",   borderColor: darkMode ? allBorderColorsInDarkMode : allBorderColorsInLightMode, borderRadius: 5, height: 'auto', marginBottom: 30 }} >
                <div 
                    style={{ margin: 15, display: 'flex', alignItems: 'center', cursor: "pointer"  }} 
                    onClick={()=> handleHideElement('hideDataDiv')} 
                >
                    <text style={{ fontWeight: 500, fontSize: 'large', flex: 1, color: darkMode ? sideHeadingColor : 'black' }} > {oldTabs[selectedTab]['symbol'] === '' && 'Data'}  {oldTabs[selectedTab]['symbol']} </text>
                    {oldTabs[selectedTab]['hideDataDiv'] ? 
                        <ExpandMoreIcon style={{ padding: 5, cursor: 'pointer' }} /> :
                        <ExpandLessIcon style={{ padding: 5, cursor: 'pointer' }} />
                    }
                </div>

                {
                    oldTabs[selectedTab]['hideDataDiv'] ? "" : 
                        <div style={{ width: "95%", margin: "30px auto", display: 'flex', flexWrap: 'wrap', justifyContent: "space-around" }} >
                            {/* TABLE_ELEMENT_START */}
                            <div style={{ width: "70%", maxWidth: isSmallScreen ? 300 : 500, display: 'flex', flexDirection: "column" }} >
                                <div style={{ display: 'flex', justifyContent: "space-between" }} >
                                    <div style={{ display: "flex", flexDirection: "column" }} >
                                        <div style={{ margin: "10px 0px", fontWeight: 700, fontSize: 'large' }}>
                                            Date
                                        </div>
                                        {oldTabs[selectedTab]['data'].map(item => 
                                            <div style={{ margin: "10px 0px" }} >{item.date}</div>
                                        )}
                                    </div>

                                    <div style={{ display: "flex", flexDirection: "column" }} >
                                        <div style={{ margin: "10px 0px", fontWeight: 700, fontSize: 'large' }}>
                                            Close
                                        </div>
                                        {oldTabs[selectedTab]['data'].map(item =>
                                            <div style={{ margin: "10px 0px" }} >{item.close.toFixed(2)}</div>
                                        )}
                                    </div>
                                </div>
                                {oldTabs[selectedTab]['swing'] === 0  ? <Button onClick={() => handleCalculate(true, 0.0)} variant="contained" style={{ margin: "15px 0px" }} color="primary" > 
                                        Calculate 
                                    </Button> : 
                                    <Button disabled variant="contained" style={{ margin: "15px 0px", color: 'white', backgroundColor: '#336537' }} > 
                                        Done 
                                    </Button>
                                }
                            </div>
                            {/* TABLE_ELEMENT_END */}

                            {/* SwingCard & Form div start */}
                            <div style={{ width: "70%", maxWidth: 300 }} >
                                {/* SwingCard_START */}

                                {(oldTabs[selectedTab]['swing'] > 0 && oldTabs[selectedTab]['swing'] === 2) ? <div style={{ display: "flex", borderRadius: 5, marginTop: isSmallScreen ? 20 : 0, height: 100, width: "100%", backgroundColor: darkMode ? "#235c27a1" : "#6bf39b94", boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px" }} >
                                    <div style={{ display: "flex", flexDirection: "column", flex: 2, justifyContent: 'center' }} >                                        
                                        <text style={{ marginLeft: 20, fontWeight: 700 }} >SWING</text>
                                        <text style={{ marginLeft: 20, marginTop: 20 }} >LOW - {oldTabs[selectedTab]['swingVal']}</text>
                                    </div>
                                    <div style={{ display: "flex", flex: 1, justifyContent: 'center', alignItems: 'center' }} >
                                        <TrendingUpIcon style={{ color: 'white', padding: 10, borderRadius: 45, backgroundColor: '#336537'  }} /> 
                                    </div>
                                </div> : "" }

                                {(oldTabs[selectedTab]['swing'] > 0 && oldTabs[selectedTab]['swing'] === 1) ? <div style={{ display: "flex", borderRadius: 5, marginTop: 20, height: 100, width: "100%", backgroundColor: darkMode ? "#ed4c34a8" : "#ffc089", boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px" }} >
                                    <div style={{ display: "flex", flexDirection: "column", flex: 2, justifyContent: 'center' }} >
                                        <text style={{ marginLeft: 20, fontWeight: 700 }} >SWING</text>
                                        <text style={{ marginLeft: 20, marginTop: 20 }} >HIGH - {oldTabs[selectedTab]['swingVal']}</text>
                                    </div>
                                    <div style={{ display: "flex", flex: 1, justifyContent: 'center', alignItems: 'center' }} >
                                        <TrendingDownIcon style={{ color: 'white', padding: 10, borderRadius: 45, backgroundColor: '#ee4b2b' }} />
                                    </div>
                                </div> : "" }

                                {/* SwingCard_END */}

                                {oldTabs[selectedTab]['swing'] != 0 && <form style={{ width: "100%",  margin: "10px 0px" }} onSubmit={(e)=> handleSubmitSwingValueForm(e)} >
                                    {darkMode ?
                                        <CssTextField
                                            variant="outlined"
                                            size="small" 
                                            label="Swing value" 
                                            id="swingvalue"
                                            name="swingvalue"
                                            style={{ width: "100%",  margin: "10px 0px", color: 'white' }}
                                        /> :
                                        <TextField
                                            id="swingvalue"
                                            name="swingvalue"
                                            label="Swing value"
                                            size="small"
                                            variant="outlined"
                                            style={{ width: "100%",  margin: "10px 0px" }}
                                        />
                                    }
                                    <button hidden type="submit"></button>
                                </form>}

                                {oldTabs[selectedTab]['swing'] != 0 && <Autocomplete
                                    id="swingType"
                                    options={swingTypes}
                                    onChange={ (e, val) => handleSwingType(val) }
                                    getOptionLabel={ (option) => option }
                                    value={swingTypes[oldTabs[selectedTab]['swingType']]}
                                    style={{ width: "100%",  margin: "10px 0px" }}
                                    renderInput={(params) => darkMode ? 
                                        <CssTextField {...params} size="small" label="Swing type" variant="outlined" />    :                                         
                                        <TextField {...params} size="small" label="Swing type" variant="outlined" />
                                    }
                                />}

                                {currentPhaseLoading ? <div style={{ display: 'flex', flex: 1, height: 200, alignItems: 'center', justifyContent: 'center' }} >
                                        <CircularProgress />
                                    </div> : !isObjectEmpty(oldTabs[selectedTab]["candleData"]) && (
                                    <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        marginBottom: 20,
                                        marginTop: 15,
                                    }}
                                    >
                                    <text
                                        style={{
                                        fontWeight: 700,
                                        marginBottom: 10,
                                        fontSize: 17,
                                        }}
                                    >
                                        Plain & non insider candle details
                                    </text>

                                    <div style={{ display: "flex" }}>
                                        <text
                                        style={{ fontWeight: 400, marginTop: 10, width: 100 }}
                                        >
                                        {" "}
                                        Date{" "}
                                        </text>
                                        <text style={{ fontWeight: 600, marginTop: 10 }}>
                                        {oldTabs[selectedTab]["candleData"]["date"].split("T")[0]}{" "}&nbsp;{" "}
                                        {oldTabs[selectedTab]["candleData"]["date"].split("T")[1]}{" "}
                                        </text>
                                    </div>
                                    <div style={{ display: "flex" }}>
                                        <text
                                        style={{ fontWeight: 400, marginTop: 10, width: 100 }}
                                        >
                                        {" "}
                                        Open{" "}
                                        </text>
                                        <text style={{ fontWeight: 600, marginTop: 10 }}>
                                        {" "}
                                        {Number(oldTabs[selectedTab]["candleData"]["open"]).toFixed(2)}{" "}
                                        </text>
                                    </div>

                                    <div style={{ display: "flex" }}>
                                        <text
                                        style={{ fontWeight: 400, marginTop: 10, width: 100 }}
                                        >
                                        {" "}
                                        High{" "}
                                        </text>
                                        <text style={{ fontWeight: 600, marginTop: 10 }}>
                                        {" "}
                                        {Number(
                                            oldTabs[selectedTab]["candleData"]["high"]
                                        ).toFixed(2)}{" "}
                                        </text>
                                    </div>

                                    <div style={{ display: "flex" }}>
                                        <text
                                        style={{ fontWeight: 400, marginTop: 10, width: 100 }}
                                        >
                                        {" "}
                                        Low{" "}
                                        </text>
                                        <text style={{ fontWeight: 600, marginTop: 10 }}>
                                        {" "}
                                        {Number(oldTabs[selectedTab]["candleData"]["low"] ).toFixed(2)}{" "}
                                        </text>
                                    </div>

                                    <div style={{ display: "flex" }}>
                                        <text
                                        style={{ fontWeight: 400, marginTop: 10, width: 100 }}
                                        >
                                        {" "}
                                        Close{" "}
                                        </text>
                                        <text style={{ fontWeight: 600, marginTop: 10 }}>
                                        {" "}
                                        {Number(
                                            oldTabs[selectedTab]["candleData"]["close"]
                                        ).toFixed(2)}{" "}
                                        </text>
                                    </div>
                                    </div>
                                )}
                        {/* Calc for current phase frm start */}
                            <div style={{ display: 'flex', flexDirection: "column" }} >                                
                                {(oldTabs[selectedTab]['swing'] != 0 && !oldTabs[selectedTab]['isDataFromManual']) ? isObjectEmpty(oldTabs[selectedTab]['candleData']) ?
                                    <Button onClick={()=> handleCalculateCurrentPhase(oldTabs[selectedTab]['swing'] == 1 ? "high" : "low" ) } variant="outlined" color="primary" > Calculate current phase </Button> :
                                    <Button disabled variant="contained" style={{ color: 'white', backgroundColor: '#336537' }} > Done </Button> : ''
                                }
                            </div>
                        </div>
                        {/* SwingCard & Form div end */}
                    </div>
                }
            </div>
            {/* DATA_TABLE_DIV_END */}

            {/* Current phase div start */}
            <div style={{ width: "100%", border: "1px solid rgba(0,0,0,0.3) ",  borderColor: darkMode ? allBorderColorsInDarkMode : allBorderColorsInLightMode, borderRadius: 5, height: 'auto', marginBottom: 30 }} >
                    <div style={{ margin: 15, display: 'flex', alignItems: 'center', cursor: "pointer"  }} onClick={()=> handleHideElement('currentPhaseDiv')} >
                        <text style={{ fontWeight: 500, fontSize: 'large', flex: 1, color: darkMode ? sideHeadingColor : 'black' }} > INITIAL / CURRENT PHASE </text>
                        {oldTabs[selectedTab]['currentPhaseDiv'] ? 
                            <ExpandMoreIcon style={{ padding: 5, cursor: 'pointer' }}  /> :
                            <ExpandLessIcon style={{ padding: 5, cursor: 'pointer' }}  />
                        }
                    </div>

                    {oldTabs[selectedTab]['currentPhaseDiv'] ? "" :
                        <div style={isSmallScreen ? { width: "95%", margin: "30px auto", display: 'flex', flexWrap: 'wrap', justifyContent: "space-around" } : { width: "96%", margin: "30px auto", display: 'flex', flexWrap: 'wrap', justifyContent: "space-between" }} >
                            {
                                oldTabs[selectedTab]['currentPhase'].map( item =>
                                    <div style={{ border: "1px solid rgba(0,0,0,0.1)",  borderColor: darkMode ? allBorderColorsInDarkMode : allBorderColorsInLightMode, borderRadius: 5, height: 230, width: 300, margin: 8, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}  >
                                        <text style={{ fontWeight: 700, fontSize: 'x-large', textAlign: 'center', marginBottom: 10  }}> {item.type} </text>
                                        <Divider style={{ backgroundColor: darkMode ? allBorderColorsInDarkMode : allBorderColorsInLightMode }} />
                                        <div style={{ height: 'auto', display: 'flex', marginTop: 25, marginBottom: 15 }} >
                                            <div style={{ display: "flex", flexDirection: "column", flex: 2, justifyContent: 'center' }} >
                                                    <text style={{ marginLeft: 20, fontSize: 'small', fontWeight: 600, color: 'green' }} >BUY SIDE</text>
                                                    <text style={{ marginLeft: 20, marginTop: 5, fontWeight: 700, color: 'green', fontSize: 'larger' }} >{item.buySide}</text>
                                                </div>
                                                <div style={{ display: "flex", flex: 1, justifyContent: 'center', alignItems: 'center' }} >
                                                    <TrendingUpIcon style={{ color: 'white', padding: 10, borderRadius: 45, backgroundColor: 'green' }} />
                                                </div>
                                        </div>
                                        <Divider style={{ backgroundColor: darkMode ? allBorderColorsInDarkMode : allBorderColorsInLightMode }} />
                                        <div style={{ height: 'auto', display: 'flex', marginTop: 25 }} >
                                            <div style={{ display: "flex", flexDirection: "column", flex: 2, justifyContent: 'center' }} >
                                                <text style={{ marginLeft: 20, fontSize: 'small', fontWeight: 600, color: '#ee4b2b' }} >SELL SIDE</text>
                                                <text style={{ marginLeft: 20, marginTop: 5, fontWeight: 700, color: '#ee4b2b', fontSize: 'larger' }} >{item.sellSide}</text>                                        
                                            </div>
                                            <div style={{ display: "flex", flex: 1, justifyContent: 'center', alignItems: 'center' }} >
                                                <TrendingDownIcon style={{ color: 'white', padding: 10, borderRadius: 45, backgroundColor: '#ee4b2b' }} />
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                            {oldTabs[selectedTab]['currentPhase'].length > 0 && <div style={{ display: 'flex', justifyContent: 'flex-end', width: "100%", marginTop: 30 }} >                                
                                <ArrowUpward onClick={() => handleCalculate(false, oldTabs[selectedTab]['currentPhase'][3]['buySide'], 1, false)}  style={{ margin: "15px 0px", color: 'white', padding: 10, borderRadius: 45, backgroundColor: 'green', cursor: 'pointer' }} />
                                <ArrowBack onClick={()=> oldTabs[selectedTab]['whichPhase'] == undefined ? "" : handleBack()}  style={{ color: 'white', padding: 10, borderRadius: 45, backgroundColor: 'blue', margin: "15px 0px", marginLeft: 15, cursor: 'pointer' }} />                                
                                <ArrowDownward onClick={() => handleCalculate(false, oldTabs[selectedTab]['currentPhase'][3]['sellSide'], 1, false)} style={{ color: 'white', padding: 10, borderRadius: 45, backgroundColor: 'red', margin: "15px 0px", marginLeft: 15, cursor: 'pointer' }} />
                            </div>}
                        </div>
                    }
            </div>
            {/* Current phase div end */}

            {/* OrderPlacementDiv_start */}
            <div style={{ width: "100%", border: "1px solid rgba(0,0,0,0.3) ",  borderColor: darkMode ? allBorderColorsInDarkMode : allBorderColorsInLightMode, borderRadius: 5, height: 'auto', marginBottom: 30 }} >
                    <div style={{ margin: 15, display: 'flex', alignItems: 'center', cursor: "pointer"  }} >
                        <text onClick={()=> handleHideElement('orderPlacementDiv')} style={{ fontWeight: 500, fontSize: 'large', flex: 1, color: darkMode ? sideHeadingColor : 'black' }} > 
                            ORDER PLACEMENT - {oldTabs[selectedTab]["symbol"]}{" "} & Trend - {oldTabs[selectedTab]["swing"] == 1 ? "SELL" : "BUY" }
                        </text>
                        
                        {/* <FormControlLabel 
                            control={
                                <Switch
                                    color={ darkMode ? "secondary" : "primary" }
                                    checked={oldTabs[selectedTab]['notify']} 
                                    onChange={(e)=> handleNotifyChange(e.target.value)}
                                />
                            }
                            label="Notify" 
                        /> */}
                        {oldTabs[selectedTab]['orderPlacementDiv'] ? 
                            <ExpandMoreIcon onClick={()=> handleHideElement('orderPlacementDiv')} style={{ padding: 5, cursor: 'pointer' }}  /> :
                            <ExpandLessIcon onClick={()=> handleHideElement('orderPlacementDiv')} style={{ padding: 5, cursor: 'pointer' }}  />
                        }
                    </div>

                    {oldTabs[selectedTab]['orderPlacementDiv'] ? "" : 
                        oldTabs[selectedTab]['orderPlaceMentBuy'].length > 0 ?  <div style={{ width: "60%", minWidth: 350 , display: 'flex', flexDirection: "column", margin: "0 auto", marginBottom: 30 }} >
                            <div
                                style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    justifyContent: "space-around",
                                }}
                            >
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <div
                                    style={{
                                        margin: "10px 0px",
                                        fontWeight: 700,
                                        textAlign: "center",
                                        fontSize: "large",
                                        color: darkMode ? "white" : "black",
                                    }}
                                    >
                                    BUY SIDE
                                    </div>
                                    {/* border: "1px solid rgba(0,0,0,0.1) ",  borderColor: darkMode ? allBorderColorsInDarkMode : allBorderColorsInLightMode */}
                                    <div
                                    style={{
                                        height: 125,
                                        width: 343,
                                        display: "flex",
                                        flexDirection: "column",
                                        borderRadius: 5,
                                        margin: "8px 0px",
                                        justifyContent: "space-around",
                                        boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
                                        backgroundColor: "green",
                                    }}
                                    >
                                    <text
                                        style={{
                                        marginLeft: 0,
                                        fontWeight: 400,
                                        fontSize: "x-large",
                                        textAlign: "center",
                                        color: "white",
                                        }}
                                    >
                                        {oldTabs[selectedTab]["orderPlaceMentBuy"][0].key}
                                    </text>
                                    <text
                                        style={{
                                        marginLeft: 0,
                                        marginTop: 5,
                                        fontWeight: 600,
                                        color: "white",
                                        textAlign: "center",
                                        fontSize: 27,
                                        }}
                                    >
                                        {oldTabs[selectedTab]["orderPlaceMentBuy"][0].value}
                                    </text>
                                    </div>

                                    <div
                                    style={{
                                        height: 125,
                                        width: 343,
                                        display: "flex",
                                        flexDirection: "column",
                                        borderRadius: 5,
                                        margin: "8px 0px",
                                        justifyContent: "space-around",
                                        boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
                                        backgroundColor: "green",
                                    }}
                                    >
                                    <text
                                        style={{
                                        marginLeft: 0,
                                        fontWeight: 400,
                                        fontSize: "x-large",
                                        textAlign: "center",
                                        color: "white",
                                        }}
                                    >
                                        {oldTabs[selectedTab]["orderPlaceMentBuy"][2].key}
                                    </text>
                                    <text
                                        style={{
                                        marginLeft: 0,
                                        marginTop: 5,
                                        fontWeight: 600,
                                        color: "white",
                                        textAlign: "center",
                                        fontSize: 27,
                                        }}
                                    >
                                        {oldTabs[selectedTab]["orderPlaceMentBuy"][2].value}
                                    </text>
                                    </div>
                                </div>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <div
                                    style={{
                                        margin: "10px 0px",
                                        fontWeight: 700,
                                        textAlign: "center",
                                        fontSize: "large",
                                        color: darkMode ? "white" : "black",
                                    }}
                                    >
                                    SELL SIDE
                                    </div>
                                    <div
                                    style={{
                                        height: 125,
                                        width: 343,
                                        display: "flex",
                                        flexDirection: "column",
                                        borderRadius: 5,
                                        margin: "8px 0px",
                                        justifyContent: "space-around",
                                        boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
                                        backgroundColor: "#ee4b2b",
                                    }}
                                    >
                                    <text
                                        style={{
                                        marginLeft: 0,
                                        fontWeight: 400,
                                        fontSize: "x-large",
                                        color: "white",
                                        textAlign: "center",
                                        }}
                                    >
                                        {oldTabs[selectedTab]["orderPlaceMentSell"][0].key}
                                    </text>
                                    <text
                                        style={{
                                        marginLeft: 0,
                                        marginTop: 5,
                                        fontWeight: 600,
                                        color: "white",
                                        textAlign: "center",
                                        fontSize: 27,
                                        }}
                                    >
                                        {oldTabs[selectedTab]["orderPlaceMentSell"][0].value}
                                    </text>
                                    </div>

                                    <div
                                    style={{
                                        height: 125,
                                        width: 343,
                                        display: "flex",
                                        flexDirection: "column",
                                        borderRadius: 5,
                                        margin: "8px 0px",
                                        justifyContent: "space-around",
                                        boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
                                        backgroundColor: "#ee4b2b",
                                    }}
                                    >
                                    <text
                                        style={{
                                        marginLeft: 0,
                                        fontWeight: 400,
                                        fontSize: "x-large",
                                        color: "white",
                                        textAlign: "center",
                                        }}
                                    >
                                        {oldTabs[selectedTab]["orderPlaceMentSell"][2].key}
                                    </text>
                                    <text
                                        style={{
                                        marginLeft: 0,
                                        marginTop: 5,
                                        fontWeight: 600,
                                        color: "white",
                                        textAlign: "center",
                                        fontSize: 27,
                                        }}
                                    >
                                        {oldTabs[selectedTab]["orderPlaceMentSell"][2].value}
                                    </text>
                                    </div>
                                </div>
                                </div>
                        </div> : "" 
                    }
                </div>

                {/* OrderPlacementDiv_end */}
                <div style={{ width: "100%", border: "1px solid rgba(0,0,0,0.3) ", borderColor: darkMode ? allBorderColorsInDarkMode : allBorderColorsInLightMode, borderRadius: 5, height: 'auto', marginBottom: 30 }} >
                    <div style={{ margin: 15, display: 'flex', alignItems: 'center', cursor: "pointer"  }} onClick={()=> handleHideElement('hideStoplossAndTargets')} >
                        <text style={{ fontWeight: 500, fontSize: 'large', flex: 1, color: darkMode ? sideHeadingColor : 'black' }} > SHOW STOP LOSS & TARGETS </text>
                        {oldTabs[selectedTab]['hideStoplossAndTargets'] ? 
                            <ExpandMoreIcon style={{ padding: 5, cursor: 'pointer' }}  /> :
                            <ExpandLessIcon style={{ padding: 5, cursor: 'pointer' }}  />
                        }
                    </div>

                    {oldTabs[selectedTab]['hideStoplossAndTargets'] ? "" : 
                        oldTabs[selectedTab]['orderPlaceMentBuy'].length > 0 ?  <div style={{ width: "60%", minWidth: 350 , display: 'flex', flexDirection: "column", margin: "0 auto", marginBottom: 30 }} >
                            <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "space-around",
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div
                      style={{
                        margin: "10px 0px",
                        fontWeight: 700,
                        textAlign: "center",
                        fontSize: "large",
                        color: darkMode ? "white" : "black",
                      }}
                    >
                      BUY SIDE
                    </div>
                    <div
                      style={{
                        height: 125,
                        width: 343,
                        display: "flex",
                        flexDirection: "column",
                        border: "1px solid rgba(0,0,0,0.1) ",
                        borderColor: darkMode
                          ? allBorderColorsInDarkMode
                          : allBorderColorsInLightMode,
                        borderRadius: 5,
                        margin: "8px 0px",
                        justifyContent: "space-around",
                        boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
                        backgroundColor: "#ee4b2b",
                      }}
                    >
                      <text
                        style={{
                          marginLeft: 0,
                          fontWeight: 400,
                          fontSize: "x-large",
                          textAlign: "center",
                          color: "white",
                        }}
                      >
                        {oldTabs[selectedTab]["orderPlaceMentBuy"][1].key}
                      </text>
                      <text
                        style={{
                          marginLeft: 0,
                          marginTop: 5,
                          fontWeight: 600,
                          color: "white",
                          textAlign: "center",
                          fontSize: 27,
                        }}
                      >
                        {oldTabs[selectedTab]["orderPlaceMentBuy"][1].value}
                      </text>
                    </div>

                    <div
                      style={{
                        height: 125,
                        width: 343,
                        display: "flex",
                        flexDirection: "column",
                        border: "1px solid rgba(0,0,0,0.1) ",
                        borderColor: darkMode
                          ? allBorderColorsInDarkMode
                          : allBorderColorsInLightMode,
                        borderRadius: 5,
                        margin: "8px 0px",
                        justifyContent: "space-around",
                        boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
                        backgroundColor: "green",
                      }}
                    >
                      <text
                        style={{
                          marginLeft: 0,
                          fontWeight: 400,
                          fontSize: "x-large",
                          textAlign: "center",
                          color: "white",
                        }}
                      >
                        {oldTabs[selectedTab]["orderPlaceMentBuy"][3].key}
                      </text>
                      <text
                        style={{
                          marginLeft: 0,
                          marginTop: 5,
                          fontWeight: 600,
                          color: "white",
                          textAlign: "center",
                          fontSize: 27,
                        }}
                      >
                        {oldTabs[selectedTab]["orderPlaceMentBuy"][3].value}
                      </text>
                    </div>

                    <div
                      style={{
                        height: 125,
                        width: 343,
                        display: "flex",
                        flexDirection: "column",
                        border: "1px solid rgba(0,0,0,0.1) ",
                        borderColor: darkMode
                          ? allBorderColorsInDarkMode
                          : allBorderColorsInLightMode,
                        borderRadius: 5,
                        margin: "8px 0px",
                        justifyContent: "space-around",
                        boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
                        backgroundColor: "green",
                      }}
                    >
                      <text
                        style={{
                          marginLeft: 0,
                          fontWeight: 400,
                          fontSize: "x-large",
                          textAlign: "center",
                          color: "white",
                        }}
                      >
                        {oldTabs[selectedTab]["orderPlaceMentBuy"][4].key}
                      </text>
                      <text
                        style={{
                          marginLeft: 0,
                          marginTop: 5,
                          fontWeight: 600,
                          color: "white",
                          textAlign: "center",
                          fontSize: 27,
                        }}
                      >
                        {oldTabs[selectedTab]["orderPlaceMentBuy"][4].value}
                      </text>
                    </div>
                  </div> 
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div
                      style={{
                        margin: "10px 0px",
                        fontWeight: 700,
                        textAlign: "center",
                        fontSize: "large",
                        color: darkMode ? "white" : "black",
                      }}
                    >
                      SELL SIDE
                    </div>
                    <div
                      style={{
                        height: 125,
                        width: 343,
                        display: "flex",
                        flexDirection: "column",
                        border: "1px solid rgba(0,0,0,0.1) ",
                        borderColor: darkMode
                          ? allBorderColorsInDarkMode
                          : allBorderColorsInLightMode,
                        borderRadius: 5,
                        margin: "8px 0px",
                        justifyContent: "space-around",
                        boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
                        backgroundColor: "#ee4b2b",
                      }}
                    >
                      <text
                        style={{
                          marginLeft: 0,
                          fontWeight: 400,
                          fontSize: "x-large",
                          color: "white",
                          textAlign: "center",
                        }}
                      >
                        {oldTabs[selectedTab]["orderPlaceMentSell"][1].key}
                      </text>
                      <text
                        style={{
                          marginLeft: 0,
                          marginTop: 5,
                          fontWeight: 600,
                          color: "white",
                          textAlign: "center",
                          fontSize: 27,
                        }}
                      >
                        {oldTabs[selectedTab]["orderPlaceMentSell"][1].value}
                      </text>
                    </div>

                    <div
                      style={{
                        height: 125,
                        width: 343,
                        display: "flex",
                        flexDirection: "column",
                        border: "1px solid rgba(0,0,0,0.1) ",
                        borderColor: darkMode
                          ? allBorderColorsInDarkMode
                          : allBorderColorsInLightMode,
                        borderRadius: 5,
                        margin: "8px 0px",
                        justifyContent: "space-around",
                        boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
                        backgroundColor: "green",
                      }}
                    >
                      <text
                        style={{
                          marginLeft: 0,
                          fontWeight: 400,
                          fontSize: "x-large",
                          color: "white",
                          textAlign: "center",
                        }}
                      >
                        {oldTabs[selectedTab]["orderPlaceMentSell"][3].key}
                      </text>
                      <text
                        style={{
                          marginLeft: 0,
                          marginTop: 5,
                          fontWeight: 600,
                          color: "white",
                          textAlign: "center",
                          fontSize: 27,
                        }}
                      >
                        {oldTabs[selectedTab]["orderPlaceMentSell"][3].value}
                      </text>
                    </div>

                    <div
                      style={{
                        height: 125,
                        width: 343,
                        display: "flex",
                        flexDirection: "column",
                        border: "1px solid rgba(0,0,0,0.1) ",
                        borderColor: darkMode
                          ? allBorderColorsInDarkMode
                          : allBorderColorsInLightMode,
                        borderRadius: 5,
                        margin: "8px 0px",
                        justifyContent: "space-around",
                        boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
                        backgroundColor: "green",
                      }}
                    >
                      <text
                        style={{
                          marginLeft: 0,
                          fontWeight: 400,
                          fontSize: "x-large",
                          textAlign: "center",
                          color: "white",
                        }}
                      >
                        {oldTabs[selectedTab]["orderPlaceMentSell"][4].key}
                      </text>
                      <text
                        style={{
                          marginLeft: 0,
                          marginTop: 5,
                          fontWeight: 600,
                          color: "white",
                          textAlign: "center",
                          fontSize: 27,
                        }}
                      >
                        {oldTabs[selectedTab]["orderPlaceMentSell"][4].value}
                      </text>
                    </div>
                  </div>
                </div>
                        </div> : "" 
                    }
                </div>

                {/* Additional details div start */}
                <div style={{ width: "100%", border: "1px solid rgba(0,0,0,0.3) ", borderColor: darkMode ? allBorderColorsInDarkMode : allBorderColorsInLightMode, borderRadius: 5, height: 'auto', marginBottom: 30 }} >
                    <div style={{ margin: 15, display: 'flex', alignItems: 'center', cursor: "pointer"  }} onClick={()=> handleHideElement('additionalDetailsDiv')} >
                        <text style={{ fontWeight: 500, fontSize: 'large', flex: 1, color: darkMode ? sideHeadingColor : 'black' }} > ADDITIONAL DETAILS </text>
                        {oldTabs[selectedTab]['additionalDetailsDiv'] ? 
                            <ExpandMoreIcon style={{ padding: 5, cursor: 'pointer' }}  /> :
                            <ExpandLessIcon style={{ padding: 5, cursor: 'pointer' }}  />
                        }
                    </div>

                    {oldTabs[selectedTab]['additionalDetailsDiv'] ? "" : 
                        oldTabs[selectedTab]['additionalDetails'].length > 0 ? <div style={{ width: "95%", margin: "30px auto", display: 'flex', flexWrap: 'wrap', justifyContent: "space-between" }} >
                            {oldTabs[selectedTab]['additionalDetails'].map(item => 
                                <div style={{ border: "1px solid rgba(0,0,0,0.1)",  borderColor: darkMode ? allBorderColorsInDarkMode : allBorderColorsInLightMode, borderRadius: 5, height: 150, width: 150, margin: 8, display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly', boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px" }} >
                                    <text style={{ textAlign: "center", fontWeight: 500, fontSize: 'large' }} > {item.key} </text>
                                    <text style={{ textAlign: "center", fontWeight: 600, fontSize: 'x-large' }} > {item.value} </text>
                                </div>
                            )}
                        </div> : ""
                    }
                </div>
            {/* Additional details div end */}
        </div> :
        <div style={{ height: "70vh", width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }} > 
            No tabs found!
            <div onClick={handleAddNewTab} style={{ display: 'flex', alignItems: 'center', color: "#000000", cursor: 'pointer', marginLeft: 10 }} className="ButtonHover" >
                <div style={{ border: '1px solid rgba(0, 0, 0, 0.1)', borderRadius: "3px", display: 'flex', padding: 5 }}>Double click to add tabs </div>
            </div>
        </div>}

        <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            key={vertical + horizontal}
            open={openSnackBar}
            onClose={handleSnackBarClose}
            autoHideDuration={2000}
            message="Symbol doesn't exist"
        >
            <Alert onClose={handleSnackBarClose} severity={snackStatus}>
                {snackMessage}
            </Alert>
        </Snackbar>
        </div>
    )
}

export default AdvancedIntraday;